export { UniversityLanding } from "./UniversityLanding";
